import cx from 'classnames';
import PropTypes from 'prop-types';

import { useStyles } from 'src/components/BouncingDots/useStyles';

export const BouncingDots = ({ className, classes }) => {
  const styles = useStyles({ classes });

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.dot} />
      <div className={styles.dot} />
      <div className={styles.dot} />
    </div>
  );
};

BouncingDots.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
};

BouncingDots.defaultProps = {
  classes: null,
  className: null,
};
